import { Outlet } from 'react-router-dom';
import PlatformAuthProvider from './PlatformAuthProvider';

const PlatformAdminLayout = () => (
  <PlatformAuthProvider>
    <Outlet />
  </PlatformAuthProvider>
);

export default PlatformAdminLayout;
